import React, { Component } from "react";
import { connect } from "react-redux";
import {
  AddMessageMail,
  fetchInfomailById,
  InsertRegisterMail,
  InterationNotifier,
} from "../actions";
import Moment from "moment";
import axios from "axios";
import MicroModal from "micromodal";
import { ReactComponent as RepeatIcon } from "../build/images/repeat.svg";
import { ReactComponent as CloseIcon } from "../build/images/icons/CloseIcon.svg";
import { ReactComponent as MoreSquareIcon } from "../build/images/moresquare.svg";
import { ReactComponent as MaximizedIcon } from "../build/images/maximize.svg";
import QuickAnswerContainer from "../containers/QuickAnswer";
import convertUnicodeEmoji from "../actions/convertUnicodeEmoji";
import BoxSendMail from "../components/mail-section/BoxSendMail";
import DEFAULT from "../build/images/default.png";
import ModalMail from "../components/mail-section/ModalMail";
import { saudacaoPorHorario } from "../utils/saudacaoPorHorario";
import { compareAsc, format, parse } from "date-fns";

MicroModal.init();

const { connection_platform } = require("../services/api");
const { meses } = require("../services/data");
var port = localStorage.getItem("port");
var pathname = localStorage.getItem("pathname");
var arrayVariables = [];
var count = 20;
let passMails = [];
let contactIDInCurse = null;
let emailsRecipients = [];
let textEmailContact = [];
let fileEmailContact = [];

const modules = {
  toolbar: [["bold", "italic", "underline", "image", "link"]],
};

const formats = ["bold", "italic", "underline", "image", "link"];

const mapStateToProps = (state) => {
  return {
    User: state.informationusers,
    ContactId: state.atendimento,
    AtdSimult: state.atdsimult,
    InfoUsers: state.informationusers,
    MailMessage: state.messagemail,
    RouterGroups: state.routergroups,
  };
};

const mapDispatchToProps = (dispatch) => ({
  sendingMailMessage: (
    operator,
    recipients,
    body_msg,
    attachments,
    date_sending,
    cdr,
    caption
  ) => {
    const externalcode = Math.floor(Math.random() * 99999123);
    dispatch(
      AddMessageMail(
        operator,
        recipients,
        body_msg,
        attachments,
        date_sending,
        cdr,
        externalcode,
        false,
        0,
        caption,
        null,
        true
      )
    );
    const params = {
      operator: operator,
      recipients: recipients,
      body_msg: body_msg,
      attachments: attachments,
      date_sending: date_sending,
      cdr: cdr,
      externalcode: externalcode,
      caption: caption,
    };
    dispatch(InsertRegisterMail(params));
  },
  interactionNotifier: () => {
    dispatch(InterationNotifier("Email enviado com sucesso", "permission"));
  },
});

class MailBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      valueQuill: "",
      isVisibleCC: false,
      isVisibleCCO: false,
      viewMails: false,
      recipients: [],
      files: [
        // {
        // label: '2222.exl'
        // },{
        //     label: '22222.pdf'
        // }
      ],
      buttonQuickAnswer: false,
      variableQuickAnwser: [],
      messageQuickAnswer: "",
      buttonMailMaximized: false,
      isEnableModalMail: false,
      isLoading: false,
      isProgress: 20,
    };
  }

  componentDidUpdate() {
    // console.log("Q#K$K@#$K 1", contactIDInCurse)
    // console.log("Q#K$K@#$K 2", this.props.ContactId.idatendimento)
    // console.log("Q#K$K@#$K 3", emailsRecipients)
    let messages = this.props.MailMessage.filter(
      (message) => message.cdr === this.props.ContactId.idatendimento
    );
    if (
      messages.length !== 0 &&
      messages[0].recipients.length !== 0 &&
      passMails[this.props.ContactId.idatendimento] !== true
    ) {
      this.setState({ recipients: messages[0].recipients });
      passMails[this.props.ContactId.idatendimento] = true;
      emailsRecipients[this.props.ContactId.idatendimento] =
        messages[0].recipients;
    }

    if (contactIDInCurse !== this.props.ContactId.idatendimento) {
      contactIDInCurse = this.props.ContactId.idatendimento;
      if (emailsRecipients[this.props.ContactId.idatendimento]) {
        this.setState({
          recipients: emailsRecipients[this.props.ContactId.idatendimento],
        });
      } else {
        this.setState({ recipients: [] });
      }
      if (textEmailContact[this.props.ContactId.idatendimento]) {
        this.setState({
          valueQuill: textEmailContact[this.props.ContactId.idatendimento],
        });
      } else {
        this.setState({ valueQuill: "" });
      }
      if (fileEmailContact[this.props.ContactId.idatendimento]) {
        this.setState({
          files: fileEmailContact[this.props.ContactId.idatendimento],
        });
      } else {
        this.setState({ files: [] });
      }
    }

    if (localStorage.getItem("email-recipient-active")) {
      this.setState({
        recipients: [
          {
            type: 1,
            label: localStorage.getItem("email-recipient-active"),
          },
        ],
      });
      localStorage.removeItem("email-recipient-active");
    }
  }

  changeInputText(e, type) {
    if (e.key === "Enter" && e.shiftKey === false) {
      let array = this.state.recipients;
      array.push({ id: 0, label: e.target.value, type: type });
      this.setState({ recipients: array });
      emailsRecipients[this.props.ContactId.idatendimento] = array;
      if (type === 1) {
        if (document.getElementById("add_recipient"))
          document.getElementById("add_recipient").value = "";

        if (document.getElementById("add_recipient_modal"))
          document.getElementById("add_recipient_modal").value = "";
      }

      if (type === 2) {
        if (document.getElementById("add_recipient_cc"))
          document.getElementById("add_recipient_cc").value = "";

        if (document.getElementById("add_recipient_cc_modal"))
          document.getElementById("add_recipient_cc_modal").value = "";

        // continuar fazendo as verificações amanhã dos campos
        // e também fazer a abreviação dos emails quando sai do campo
      }

      if (type === 3) {
        if (document.getElementById("add_recipient_cco"))
          document.getElementById("add_recipient_cco").value = "";

        if (document.getElementById("add_recipient_cco_modal"))
          document.getElementById("add_recipient_cco_modal").value = "";
      }
    }
  }

  setValueQuill(e) {
    this.setState({ valueQuill: e.target.value });
    textEmailContact[this.props.ContactId.idatendimento] = e.target.value;
  }

  handleTextQuill(text, bind) {
    bind.setState({ valueQuill: text });
    textEmailContact[bind.props.ContactId.idatendimento] = text;
  }

  removeRecipient(e, index) {
    let array = this.state.recipients;
    array.splice(index, 1);
    this.setState({ recipients: array });
    textEmailContact[this.props.ContactId.idatendimento] = [];
  }

  removeFile(e, index, bind) {
    let array = bind.state.files;
    array.splice(index, 1);
    bind.setState({ files: array });
    fileEmailContact[bind.props.ContactId.idatendimento] = array;
  }

  DisplayQuickAnswer(e) {
    e.preventDefault();
    this.setState({ buttonQuickAnswer: !this.state.buttonQuickAnswer });
    const { RespostasRapidas } = this.props;
    this.state.respostasinicial = RespostasRapidas.respostas;
    this.state.respostas = this.state.respostasinicial;
    this.setState({ messageQuickAnswer: "", variableQuickAnwser: [] });
    if (this.state.buttonQuickAnswer) {
      document.getElementById("input-msgs-rapidas").value = "";
    }
  }

  async getInfomailById(id) {
    const infos = {
      isError: false,
      data: null,
    };
    const response = await fetchInfomailById(id);
    const hasError =
      !Boolean(response) || (Boolean(response) && response.status !== 200);
    if (hasError) {
      infos.isError = true;
      infos.data = null;
      return infos;
    }
    const hasData =
      Boolean(response) &&
      Array.isArray(response.data) &&
      response.data.length > 0;
    if (!hasData) {
      infos.isError = false;
      infos.data = null;
      return infos;
    }

    infos.isError = false;
    infos.data = response.data[0].externalcode;
    return infos;
  }

  async sendMailMessage(bind) {
    try {
      const { recipients, valueQuill, files, isProgress } = bind.state;
      const { User, ContactId, RouterGroups } = bind.props;

      // console.log("234l235l2", bind.props.MailMessage)
      // console.log("234l235l2", ContactId)

      // return true

      if (recipients.length !== 0 && valueQuill !== "<p><br></p>") {
        bind.loadingProgress(bind);
        let listMails = recipients
          .filter((recipient) => recipient.type === 1 || recipient.type === 0)
          .map((email) => email.label);
        let listMailsCC = recipients
          .filter((recipient) => recipient.type === 2)
          .map((email) => email.label);
        let listFiles = files.map((file) => file.url);

        try {
          console.log("INGENIUM_ROTAEMAIL_0 : ", RouterGroups);

          let troncoEmail = RouterGroups.filter(
            (rtgrp) => parseInt(rtgrp.idmidia) === 3
          );

          let emailOrigem = "";
          let emailEndpoint = "";
          let emailToken = "";
          //aqui irei verificar a rota de email configurada para o usuario

          if (troncoEmail.length > 0) {
            console.log("INGENIUM_ROTAEMAIL_1 : ", troncoEmail[0]);
            emailOrigem = troncoEmail[0].tech;
            console.log("INGENIUM_ROTAEMAIL_ORIGEM : ", troncoEmail[0].tech);
            emailEndpoint = troncoEmail[0].useprefix;
            console.log(
              "INGENIUM_ROTAEMAIL_ENDPOINT : ",
              troncoEmail[0].useprefix
            );
            emailToken = troncoEmail[0].token;
            console.log("INGENIUM_ROTAEMAIL_TOKEN : ", troncoEmail[0].token);

            const jsonMail = {
              CDR: ContactId.idatendimento,
              ASSUNTO:
                parseInt(ContactId.direction) === 1
                  ? ContactId.nomesubservico
                  : ContactId.servico,
              DESTINATARIO: listMails.join(),
              COPIA: listMailsCC.join(),
              ANEXO: listFiles.join(),
              CORPOEMAIL: valueQuill,
              ORIGEM: emailOrigem,
              // MSG_ID: 1
            };

            if (ContactId.direction === "1") {
              if (
                bind.props.MailMessage.length !== 0 &&
                bind.props.MailMessage[0].msg_id
              ) {
                let mailMessage = bind.props.MailMessage.filter(
                  (message) =>
                    parseInt(ContactId.idatendimento) === parseInt(message.cdr)
                );
                if (mailMessage.length !== 0) {
                  let msgIdOfLastClientMessage = mailMessage[0].msg_id;
                  const lastMsgOfClient = mailMessage
                    .sort((a, b) => {
                      try {
                        const dataA = parse(
                          a.date_sending,
                          "dd/MM/yyyy HH:mm",
                          new Date()
                        );
                        const dataB = parse(
                          b.date_sending,
                          "dd/MM/yyyy HH:mm",
                          new Date()
                        );

                        const order = compareAsc(dataA, dataB);
                        if (order === 0 && Boolean(a.id) && Boolean(b.id)) {
                          return parseInt(a.id) - parseInt(b.id);
                        }
                        return order;
                      } catch {
                        return 0;
                      }
                    })
                    .findLast((mail) => !mail.isAgent);
                  if (Boolean(lastMsgOfClient)) {
                    const getInfomailById = async (id) => {
                      const infos = {
                        isError: false,
                        data: null,
                      };
                      const response = await fetchInfomailById(id);
                      const hasError =
                        !Boolean(response) ||
                        (Boolean(response) && response.status !== 200);
                      if (hasError) {
                        infos.isError = true;
                        infos.data = null;
                        return infos;
                      }
                      const hasData =
                        Boolean(response) &&
                        Array.isArray(response.data) &&
                        response.data.length > 0;
                      if (!hasData) {
                        infos.isError = false;
                        infos.data = null;
                        return infos;
                      }

                      infos.isError = false;
                      infos.data = response.data[0].externalcode;
                      return infos;
                    };
                    const externalCode = await getInfomailById(
                      lastMsgOfClient.id
                    );
                    if (externalCode.isError) {
                      return;
                    }
                    if (externalCode.data) {
                      msgIdOfLastClientMessage = externalCode.data;
                    }
                  }
                  jsonMail.MSG_ID = msgIdOfLastClientMessage;
                }
              }
            }
            // ALTERADO DIA 22/10/2024 PARA BUSCAR DA ROTA DO USUÁRIO
            // const sendMail = await axios.post(`${connection_platform.url_mail}/`, jsonMail);
            const sendMail = await axios.post(`${emailEndpoint}/`, jsonMail, {
              headers: {
                Authorization: emailToken,
              },
            });

            if (sendMail.data.SUCCESS === "TRUE") {
              bind.props.interactionNotifier();
              bind.props.sendingMailMessage(
                User.displayname,
                recipients,
                valueQuill,
                files,
                format(new Date(), "dd/MM/yyyy HH:mm"),
                ContactId.idatendimento,
                parseInt(ContactId.direction) === 1
                  ? ContactId.nomesubservico
                  : ContactId.servico
              );
              bind.clearFields(bind);
              // MicroModal.close('modal__mail-maximized')
              bind.setState({ isLoading: false, isProgress: 20 });
              count = 20;
            } else {
              bind.setState({ isLoading: false, isProgress: 20 });
              count = 20;
            }
          } else {
            console.log("Nenhuma rota de e-mail encontrada.");
          }
        } catch (error) {
          bind.setState({ isLoading: false, isProgress: 20 });
          return true;
        }
      }
    } catch (error) {
      console.log("sendMailMessage ERROR: ", error);
    }
  }

  loadingProgress(bind) {
    bind.setState({ isLoading: true });
    let intervalCount = setInterval(() => {
      if (count === 100) {
        clearInterval(intervalCount);
        bind.setState({ isProgress: 20 });
      }
      if (count < 100) {
        bind.setState({ isProgress: count + 20 });
        count = count + 20;
      }
    }, [1000]);
  }

  clearFields(bind) {
    bind.setState({
      valueQuill: "",
      isVisibleCC: false,
      isVisibleCCO: false,
      viewMails: false,
      // recipients: [],
      files: [],
    });
    textEmailContact[this.props.ContactId.idatendimento] = "";
    fileEmailContact[this.props.ContactId.idatendimento] = [];
  }

  changeTextQuill(e, textValue, bind, editable, mimetypeid, screen) {
    textValue = textValue.replace(/(?:\r\n|\r|\n)/gm, "<br />");
    textValue = convertUnicodeEmoji(textValue);
    bind.verifierVariablesQuickAnswer(
      textValue,
      editable,
      mimetypeid,
      bind,
      screen
    );
    bind.setState({ valueQuill: textValue });
    textEmailContact[this.props.ContactId.idatendimento] = textValue;
    // document.getElementById('input_teste_view').click();
  }

  verifierVariablesQuickAnswer(
    textReceived,
    editable,
    mimetypeid,
    bind,
    screen
  ) {
    const { ContactId, InfoUsers } = this.props;
    try {
      let regex = new RegExp("{(.*?)}", "g");
      let result;
      let array = [];

      while ((result = regex.exec(textReceived))) {
        let value = result[1];
        value = value.replace(
          "SYS.SOCIALNAME",
          convertUnicodeEmoji(ContactId.cliente.trim())
        );
        value = value.replace(
          "SYS.NOMEAGENTE",
          convertUnicodeEmoji(InfoUsers.displayname.trim())
        );
        const saudacao = saudacaoPorHorario();
        value = value.replace("SYS.SAUDACAO", convertUnicodeEmoji(saudacao));
        value = value.replace("SYS.GREETING", convertUnicodeEmoji(saudacao));
        array.push({
          id: result[1],
          name: result[1],
          value: value === result[1] ? "${" + value + "}" : value,
        }); // mostra o que está entre os :
      }

      if (array.length !== 0 && mimetypeid === 30 && editable === true) {
        if (screen === "modal-mail") {
          MicroModal.close("modal__mail-maximized");
          bind.setState({ isEnableModalMail: true });
        }
        MicroModal.show("modal__mensagens-predefinidas");
        bind.setState({
          messageQuickAnswer: textReceived,
          variableQuickAnwser: array,
        });
      }
    } catch {
      console.log("ERROR");
    }
  }

  changeViewQuickAnswer(bind) {
    bind.setState({ buttonQuickAnswer: !bind.state.buttonQuickAnswer });
  }

  changeVisibleMailMaximized(bind, screen) {
    if (screen === "attendance") {
      this.props.changeVisibleBoxMail(this.props.bindAttendance);
      this.setState({ buttonMailMaximized: !this.state.buttonMailMaximized });
    } else {
      bind.props.changeVisibleBoxMail(bind.props.bindAttendance);
      bind.setState({ buttonMailMaximized: !bind.state.buttonMailMaximized });
      if (screen === "maximized") MicroModal.close("modal__mail-maximized");
    }
  }

  changeVisibleModalMail(bind, screen) {
    MicroModal.show("modal__mail-maximized");
  }

  changeViewScriptId() {
    document.getElementById("input_teste_view").click();
  }

  async handleselectedFile(event) {
    let filesend = event.target.files[0];
    if (filesend != undefined) {
      this.setState({
        selectedFile: filesend,
      });
      let data = new FormData();
      let namefile = filesend.name;
      let hora = Moment().format("HH-mm-ss");
      let random = Math.floor(Math.random() * 999999 + 100000);
      random = random + "_" + hora;
      let ext = namefile.split(".").pop();
      namefile = random + "." + ext;
      data.append("file", filesend, namefile);
      axios
        .post(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/insertupload`,
          data
        )
        .then((res) => {
          let dia = Moment().format("DD");
          let mes = Moment().format("MM");
          mes = meses.indexOf(mes);
          dia = dia + " de " + meses[mes - 1];
          let arrayFiles = this.state.files;
          arrayFiles.push({
            label: res.data.file.split("/").pop(),
            url: res.data.file,
            path: res.data.file,
          });
          this.setState({ files: arrayFiles });
          fileEmailContact[this.props.ContactId.idatendimento] = arrayFiles;
        });
    }
    document.getElementById("file-input-mail").value = "";
  }

  saveVariablesQuick() {
    this.setState({ variableQuickAnwser: arrayVariables });
  }

  changeVariablesSending(array) {
    arrayVariables = array;
    document.getElementById("button-save-variables").click();
  }

  actionCancelMessageClient() {
    MicroModal.close("modal__agenda-pj-empresa-detalhes-editar-respostas");
    document.getElementById("chat-message").innerText = "";
  }

  sendTextInputChat(textReceived, bind) {
    bind.setState({ valueQuill: textReceived });
    textEmailContact[this.props.ContactId.idatendimento] = textReceived;
  }

  confirmQuickAnswer(bind) {
    MicroModal.close("modal__mensagens-predefinidas");
    if (bind.state.isEnableModalMail) {
      MicroModal.show("modal__mail-maximized");
      bind.setState({ isEnableModalMail: false });
    }
  }

  actionCancelMessageClient(event, bind) {
    bind.setState({ valueQuill: "", isEnableModalMail: false });
    textEmailContact[this.props.ContactId.idatendimento] = "";
    MicroModal.close("modal__mensagens-predefinidas");
    if (bind.state.isEnableModalMail) {
      MicroModal.show("modal__mail-maximized");
    }
  }

  captureText(text, type) {
    if (text !== "") {
      let array = this.state.recipients;
      array.push({ id: 0, label: text, type: type });
      this.setState({ recipients: array });
      if (type === 1) document.getElementById("add_recipient").value = "";

      if (type === 2) document.getElementById("add_recipient_cc").value = "";

      if (type === 3) document.getElementById("add_recipient_cco").value = "";
    }
  }

  handleFieldInput() {
    this.setState({ viewMails: true });
    document.getElementById("add_recipient").focus();
    setTimeout(() => {
      document.getElementById("add_recipient").focus();
    }, [300]);
  }

  render() {
    const {
      recipients,
      valueQuill,
      viewMails,
      isVisibleCC,
      isVisibleCCO,
      messageQuickAnswer,
      variableQuickAnwser,
      files,
      buttonQuickAnswer,
      buttonMailMaximized,
      isLoading,
      isProgress,
    } = this.state;

    const { ContactId } = this.props;

    // console.log("ISTO E UMS MAIL", localStorage.getItem("email-recipient-active"));

    return (
      <div
        className={
          this.props.isVisibleBox
            ? "message-box-mail__container"
            : "message-box-mail__nullable"
        }
      >
        {this.props.isVisibleBox && (
          <>
            <div className="message-box-mail__new">
              <div className="message-box-mail__header-repeat">
                <RepeatIcon />
                <span>
                  <b>Nova Mensagem</b>
                </span>
              </div>
              <div className="message-box-mail__header-right">
                <div
                  className="message-box-mail__header-right_more"
                  onClick={(event) =>
                    this.changeVisibleMailMaximized(this, "attendance")
                  }
                >
                  <MoreSquareIcon />
                </div>
                <div
                  className="message-box-mail__header-right_maximized"
                  onClick={(event) =>
                    this.changeVisibleModalMail(this, "attendance")
                  }
                >
                  <MaximizedIcon />
                </div>
              </div>
            </div>
            <div className="message-box-mail__container-header">
              <div className="message-box-mail__header">
                <div className="message-box-mail__header-box_recipient">
                  <div
                    onClick={(event) => this.handleFieldInput(event)}
                    // style={{height: viewMails ? '15px':'25px', width: viewMails === false && recipients.length === 0 ? '500px':''}}
                    style={{
                      width:
                        viewMails === false && recipients.length === 0
                          ? "500px"
                          : "",
                    }}
                  >
                    <span className="message-box-mail__header-box_recipient-span">
                      Para:
                    </span>
                  </div>
                  {viewMails === true ? (
                    <>
                      {recipients
                        .filter(
                          (recipient) =>
                            recipient.type === 1 || recipient.type === 0
                        )
                        .map((recipient, index) => (
                          <div className="message-box-mail__header-recipient-more">
                            {recipient.label}
                            <div
                              className="message-box-mail__header-recipient__icon"
                              onClick={(event) =>
                                this.removeRecipient(event, index)
                              }
                            >
                              <CloseIcon />
                            </div>
                          </div>
                        ))}
                      <input
                        id="add_recipient"
                        name="email"
                        // style={{display: viewMails ? 'block':'block'}}
                        onFocus={(event) => this.setState({ viewMails: true })}
                        onBlur={(event) =>
                          this.captureText(event.target.value, 1)
                        }
                        onKeyPress={(event) => this.changeInputText(event, 1)}
                        className={
                          viewMails
                            ? "message-box-mail__header-recipient__input"
                            : "message-box-mail__header-recipient__input-disabled"
                        }
                      />
                    </>
                  ) : (
                    <>
                      {recipients.slice(0, 1).map((recipient, index) => (
                        <div
                          className="message-box-mail__header-recipient-many"
                          onClick={(event) =>
                            this.setState({ viewMails: true })
                          }
                        >
                          {recipient.label}
                        </div>
                      ))}
                      {recipients.length > 1 && (
                        <div
                          onClick={(event) =>
                            this.setState({ viewMails: true })
                          }
                          className="message-box-mail__header-recipient-hide"
                        >
                          Mais {recipients.length - 1}
                        </div>
                      )}
                    </>
                  )}
                </div>
                {viewMails === true && (
                  <div className="message-box-mail__header-box_action">
                    <div className="message-box-mail__header-box_action_cc">
                      <span
                        className="fields_mail"
                        onClick={() =>
                          this.setState({
                            isVisibleCC:
                              recipients.filter(
                                (recipient) => recipient.type === 2
                              ).length !== 0
                                ? true
                                : false,
                          })
                        }
                      >
                        Cc:
                      </span>
                      {/* {isVisibleCC &&
                                            <> */}
                      {recipients
                        .filter((recipient) => recipient.type === 2)
                        .map((recipient, index) => (
                          <div className="message-box-mail__header-recipient-more">
                            {recipient.label}
                            <div
                              className="message-box-mail__header-recipient__icon"
                              onClick={(event) =>
                                this.removeRecipient(event, index)
                              }
                            >
                              <CloseIcon />
                            </div>
                          </div>
                        ))}
                      <div className="message-box-mail__header-recipient__digited">
                        <input
                          id="add_recipient_cc"
                          name="email"
                          onFocus={(event) =>
                            this.setState({ viewMails: true })
                          }
                          onKeyPress={(event) => this.changeInputText(event, 2)}
                          onBlur={(event) =>
                            this.captureText(event.target.value, 2)
                          }
                          className="message-box-mail__header-recipient__cc"
                        />
                      </div>
                      {/* </>
                                        } */}
                    </div>
                    <div className="message-box-mail__header-box_action_cco">
                      <span
                        className="fields_mail"
                        onClick={() =>
                          this.setState({
                            isVisibleCCO:
                              recipients.filter(
                                (recipient) => recipient.type === 3
                              ).length !== 0
                                ? true
                                : false,
                          })
                        }
                      >
                        Cco:
                      </span>
                      {/* {isVisibleCCO &&
                                            <> */}
                      {recipients
                        .filter((recipient) => recipient.type === 3)
                        .map((recipient, index) => (
                          <div className="message-box-mail__header-recipient-more">
                            {recipient.label}
                            <div
                              className="message-box-mail__header-recipient__icon"
                              onClick={(event) =>
                                this.removeRecipient(event, index)
                              }
                            >
                              <CloseIcon />
                            </div>
                          </div>
                        ))}
                      <input
                        id="add_recipient_cco"
                        name="email"
                        onFocus={(event) => this.setState({ viewMails: true })}
                        onBlur={(event) =>
                          this.captureText(event.target.value, 3)
                        }
                        onKeyPress={(event) => this.changeInputText(event, 3)}
                        className="message-box-mail__header-recipient__cco"
                      />
                      {/* </>
                                        } */}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
        {!this.props.isVisibleBox && (
          <div className="message-box-mail__disable-box">
            <img src={DEFAULT} width="36" />
            <span className="message-box-mail__disable-box__text">
              Você está editando sua resposta em uma janela separada.
            </span>
          </div>
        )}
        <BoxSendMail
          files={files}
          recipients={recipients}
          viewMails={viewMails}
          modules={modules}
          formats={formats}
          valueQuill={valueQuill}
          removeFile={this.removeFile}
          bind={this}
          changeTextQuill={this.changeTextQuill}
          buttonQuickAnswer={buttonQuickAnswer}
          buttonMailMaximized={buttonMailMaximized}
          changeViewQuickAnswer={this.changeViewQuickAnswer}
          changeVisibleMailMaximized={this.changeVisibleMailMaximized}
          isVisibleBox={this.props.isVisibleBox}
          sendMailMessage={this.sendMailMessage}
          isLoading={isLoading}
          isProgress={isProgress}
          ContactId={ContactId}
          handleTextQuill={this.handleTextQuill}
        />
        <input
          style={{ display: "none" }}
          type="file"
          name="upload"
          id="file-input-mail"
          onChange={(event) => this.handleselectedFile(event)}
        />
        <QuickAnswerContainer
          message={messageQuickAnswer}
          variables={variableQuickAnwser}
          sendTextInputChat={this.sendTextInputChat}
          actionSendMessageClient={this.confirmQuickAnswer}
          actionCancelMessageClient={this.actionCancelMessageClient}
          changeVariablesSending={this.changeVariablesSending}
          bind={this}
          screen="mail"
        />
        <ModalMail
          files={files}
          recipients={recipients}
          viewMails={viewMails}
          modules={modules}
          formats={formats}
          valueQuill={valueQuill}
          removeFile={this.removeFile}
          bind={this}
          changeTextQuill={this.changeTextQuill}
          buttonQuickAnswer={buttonQuickAnswer}
          buttonMailMaximized={buttonMailMaximized}
          changeViewQuickAnswer={this.changeViewQuickAnswer}
          changeVisibleMailMaximized={this.changeVisibleMailMaximized}
          isVisibleBox={this.props.isVisibleBox}
          sendMailMessage={this.sendMailMessage}
          ContactId={ContactId}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MailBox);
